import React from 'react'
import InfoCard from '../InfoCard'
import NoMark from '../NoMark'
import styles from './styles.module.scss'

interface ResultCardProps {
    resultMessage: {
        type: 'success' | 'failure'
        title: string
        message: string
        cta?: {
            label: string
            action: string
        }
    }
    onStartClaim?: () => void
    onReset?: () => void
}

// The eligibility outcome, in the same card as the "Private & secure" info,
// shown inline in place of the questions
const ResultCard: React.FC<ResultCardProps> = ({ resultMessage, onStartClaim, onReset }) => {
    const action =
        resultMessage.cta && onStartClaim
            ? { label: resultMessage.cta.label, onClick: onStartClaim }
            : { label: 'Start over', onClick: onReset ?? (() => {}) }

    return (
        <div className={styles.flowContainer}>
            <InfoCard
                title={resultMessage.title}
                action={action}
                role="status"
                // A silver cross for "not eligible"; the orb otherwise
                visual={resultMessage.type === 'failure' ? <NoMark size={88} /> : undefined}
            >
                {resultMessage.message}
            </InfoCard>
        </div>
    )
}

export default ResultCard
